<div
  class="jp-bets__wrapper"
  [class.waiting]="
    round().status !== 'ended' &&
    !(round().status === 'running' || round().status === 'rolling')
  "
>
  <div class="jp-bets__total">
    <span> Winner value: </span>
    <app-cost [cost]="round().value" color="var(--yellow)" [balanceType]="'skins'" />
  </div>
  @if (round().status === 'running' || round().status === 'rolling') {
  <div class="jp-bets__timer">
    @if (round().status === 'running') { Round starts in
    {{ timer() }}... } @else { Running... }
  </div>
  <div
    class="jp-bets__hash"
    (click)="clipboardService.copy(round().hash, 'Hash copied!')"
  >
    Hash: <span>{{ round().hash }}</span>
  </div>
  }

  <!--  -->
  @if (round().status === 'ended') {
  <app-fairness-button
    class="jp-bets__fairness"
    [href]="'/provably-fair/jackpot/' + round().gameid"
  ></app-fairness-button>

  @if (!!round().winner) {
  <!--  -->
  @let winner = round().winner!;
  <div class="jp-bets__winner-bet">
    <span> Winner bet: </span>
    <app-cost [cost]="winner.total_value" color="var(--yellow)" [balanceType]="'skins'" />
  </div>
  <div
    class="jp-bets__winner"
    [style.--winner-color]="
      winner.user_color
    "
  >
    <app-player-row
      class="jp-user-bet__player"
      (click)="
        contextMenuService.open($event, {
          user: winner
        })
      "
      [player]="winner"
      [rowSettings]="{
  avatar: {
    borderColor: winner.user_color,
    filter: 'drop-shadow(0px 0px 12px ' + winner.user_color + 66 + ')',
  }
}"
    ></app-player-row>
    <span>has won the jackpot!</span>
  </div>
  }
  <!--  -->
  }
  <!--  -->
  @if (round().status === 'ended') {
  <div class="jp-bets__winner-badge">
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/old-images/cup.svg"
    />
    WINNER
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/old-images/cup.svg"
    />
  </div>
  } @if (round().status !== 'ended' && !(round().status === 'running' ||
  round().status === 'rolling')) {
  <div class="jp-bets__waiting dots-animation" (click)="openJoinGame()">
    Waiting for players to join
  </div>
  }
</div>
<div class="jp-bets__list" [@listAnimation]="round().bets.length">
  @for (bet of round().bets; track index; let index = $index) {
  <app-jackpot-user-bet
    class="bet"
    [bet]="bet"
    [isEnd]="round().status === 'ended'"
    [isWinner]="round().winner?.steamid === bet.steamid"
  ></app-jackpot-user-bet>
  }
</div>
